export default __webpack_public_path__ + "static/media/RenewNow.7d903432.svg";